/* eslint-disable no-param-reassign */
import _, { pick } from 'lodash';

export default {
  addTasks(state, { tasks }) {
    const groupByGanttId = _.groupBy(tasks, 'gantt_id');

    Object.keys(groupByGanttId).forEach(ganttId => {
      const projectData = state.data.find(o => o.id === +ganttId);

      if (!projectData) {
        return;
      }

      const tasksToAdd = groupByGanttId[ganttId].map(task => {
        return { ...task };
      });

      projectData.tasks.push(...tasksToAdd);
    });
  },

  updateTasks(state, { tasks }) {
    const groupByGanttId = _.groupBy(tasks, 'gantt_id');

    Object.keys(groupByGanttId).forEach(ganttId => {
      const updatedTasksMap = _.keyBy(groupByGanttId[ganttId], 'id');
      const projectData = state.data.find(o => +o.id === +ganttId);

      if (!projectData) {
        return;
      }

      projectData.tasks.forEach((task, index) => {
        const updatedTaskData = updatedTasksMap[task.id];

        if (updatedTaskData) {
          projectData.tasks[index] = {
            ...projectData.tasks[index],
            ...updatedTaskData,
          };
        }
      });
    });
  },

  updateTasksIds(state, payload) {
    // payload = {
    //   createdTasks: [
    //     {
    //       sourceTaskId: payload.sourceTaskId,
    //       targetTaskId: payload.targetTaskId,
    //       ganttId: payload.ganttId,
    //     },
    //   ],
    // };

    const groupByGanttId = _.groupBy(payload.createdTasks, 'ganttId');

    Object.entries(groupByGanttId).forEach(([ganttId, createdTasks]) => {
      const createdTaskMap = _.keyBy(createdTasks, 'sourceTaskId');
      const projectData = state.data.find(o => +o.id === +ganttId);

      if (!projectData) {
        return;
      }

      projectData.tasks.forEach((task, index) => {
        if (createdTaskMap[task.id]) {
          projectData.tasks[index] = {
            ...projectData.tasks[index],
            id: createdTaskMap[task.id].targetTaskId,
          };
        }
      });
    });
  },

  deleteTasks(state, payload) {
    const groupByGanttId = _.groupBy(payload.tasks, 'gantt_id');

    Object.keys(groupByGanttId).forEach(ganttId => {
      const deletedTasksMap = _.keyBy(groupByGanttId[ganttId], 'id');
      const projectData = state.data.find(o => +o.id === +ganttId);

      if (!projectData) {
        return;
      }

      projectData.tasks = [...projectData.tasks.filter(t => !deletedTasksMap[t.id])];
    });
  },

  addLinks(state, { links }) {
    const groupByGanttId = _.groupBy(links, 'gantt_id');

    Object.keys(groupByGanttId).forEach(ganttId => {
      const projectTasksData = state.data.find(o => o.id === +ganttId);
      const linksToCreate = groupByGanttId[ganttId];

      if (!projectTasksData) return;

      linksToCreate.forEach(link => {
        link.lag = link.lag || 0;
        link.source = +link.source;
        link.target = +link.target;
      });

      projectTasksData.links.push(...linksToCreate);
    });
  },

  updateLinks(state, { links }) {
    const groupByGanttId = _.groupBy(links, 'gantt_id');

    Object.keys(groupByGanttId).forEach(ganttId => {
      const updatedLinksMap = _.keyBy(groupByGanttId[ganttId], 'id');
      const projectData = state.data.find(o => +o.id === +ganttId);

      if (!projectData) {
        return;
      }

      projectData.links.forEach((link, index) => {
        const updatedLinkData = updatedLinksMap[link.id];

        if (updatedLinkData) {
          projectData.links[index] = {
            ...projectData.links[index],
            lag: updatedLinkData.lag,
          };
        }
      });
    });
  },

  updateLinksIds(state, payload) {
    // payload = {
    //   createdLinks: [
    //     {
    //       sourceLinkId: payload.sourceLinkId,
    //       targetLinkId: payload.targetLinkId,
    //       ganttId: payload.ganttId
    //     },
    //   ],
    // };

    const groupByGanttId = _.groupBy(payload.createdLinks, 'ganttId');

    Object.entries(groupByGanttId).forEach(([ganttId, createdLinks]) => {
      const projectData = state.data.find(o => +o.id === +ganttId);
      const createdLinkMap = _.keyBy(createdLinks, 'sourceLinkId');

      projectData.links.forEach((link, index) => {
        if (createdLinkMap[link.id]) {
          projectData.links[index] = {
            ...projectData.links[index],
            id: createdLinkMap[link.id].targetLinkId,
          };
        }
      });
    });
  },

  removeLinks(state, { links }) {
    const groupByGanttId = links.reduce((result, link) => {
      if (!result[link.gantt_id]) {
        result[link.gantt_id] = [];
      }

      result[link.gantt_id].push(link.id);

      return result;
    }, {});

    Object.keys(groupByGanttId).forEach(ganttId => {
      const projectData = state.data.find(o => o.id === +ganttId);

      projectData.links = projectData.links.filter(l => !groupByGanttId[ganttId].includes(l.id));
    });
  },

  updateResourcesToTasks(state, payload) {
    // payload = {
    //   resourcesToTasks: [
    //     {
    //       ganttId: payload.ganttId,
    //       taskId: payload.taskId,
    //       resourcesToTask: payload.resourcesToTask,
    //     },
    //   ],
    // };

    const groupByGanttId = _.groupBy(payload.resourcesToTasks, 'ganttId');

    Object.entries(groupByGanttId).forEach(([ganttId, updatedResourcesToTasks]) => {
      const projectData = state.data.find(o => o.id === +ganttId);

      if (!projectData) {
        return;
      }

      updatedResourcesToTasks.forEach(({ taskId, resourcesToTask }) => {
        projectData.resourcesToTasks[taskId] = resourcesToTask.length ? resourcesToTask : null;
      });
    });
  },

  updateResourcesToTasksIds(state, payload) {
    // payload = {
    //   resourcesToTasks: [
    //     {
    //       ganttId: payload.ganttId,
    //       taskId: payload.taskId,
    //       resourcesToTask: payload.resourcesToTask,
    //     },
    //   ],
    // };

    const groupByGanttId = _.groupBy(payload.resourcesToTasks, 'ganttId');

    Object.entries(groupByGanttId).forEach(([ganttId, updatedResourcesToTasks]) => {
      const updatedTasksMap = {};
      const projectData = state.data.find(o => o.id === +ganttId);

      if (!projectData) {
        return;
      }

      updatedResourcesToTasks.forEach(({ taskId, resourcesToTask }) => {
        projectData.resourcesToTasks[taskId] = resourcesToTask.length ? resourcesToTask : null;
        updatedTasksMap[taskId] = { resources: resourcesToTask };
      });

      projectData.tasks.forEach((task, index) => {
        const updatedTaskData = updatedTasksMap[task.id];

        if (updatedTaskData) {
          projectData.tasks[index] = {
            ...projectData.tasks[index],
            ...updatedTaskData,
          };
        }
      });
    });
  },

  updateTasksCustomValues(state, payload) {
    // payload = {
    //   tasksCustomValues: [
    //     {
    //       ganttId: payload.ganttId,
    //       taskId: payload.taskId,
    //       tasksCustomValues: payload.tasksCustomValues,
    //     },
    //   ],
    // };

    const groupByGanttId = _.groupBy(payload.tasksCustomValues, 'ganttId');

    _.forOwn(groupByGanttId, (updatedTasksCustomValues, ganttId) => {
      const projectData = state.data.find(o => o.id === +ganttId);

      if (!projectData || !projectData.customValues) {
        return;
      }

      updatedTasksCustomValues.forEach(({ taskId, tasksCustomValues }) => {
        projectData.customValues[taskId] = {
          ...(projectData.customValues ? projectData.customValues[taskId] : {}),
          ...tasksCustomValues,
        };
      });
    });
  },

  updateTasksCustomValuesTasksIds(state, payload) {
    // payload = {
    //   tasks: [
    //     {
    //       sourceTaskId: payload.sourceTaskId,
    //       targetTaskId: payload.targetTaskId,
    //       ganttId: payload.ganttId,
    //     },
    //   ],
    // };

    const groupByGanttId = _.groupBy(payload.tasks, 'ganttId');

    _.forOwn(groupByGanttId, (tasks, ganttId) => {
      const tasksMap = _.keyBy(tasks, 'sourceTaskId');
      const projectData = state.data.find(o => +o.id === +ganttId);

      if (!projectData) {
        return;
      }

      _.forOwn(projectData.customValues, (customValues, taskId) => {
        if (tasksMap[taskId]) {
          projectData.customValues[tasksMap[taskId].targetTaskId] = customValues;
          delete projectData.customValues[taskId];
        }
      });
    });
  },
  updateStoreItem(state, payload) {
    const storeItemData = state.data.find(o => o.id === payload.ganttId);

    const index = state.data.map(o => o.id).indexOf(payload.ganttId);

    if (payload) {
      state.data[index] = { ...storeItemData, ...payload };
    }
  },
};
